module.exports = __webpack_public_path__ + "static/media/footer_logo@2x.077de17b.png";